import { DialogM } from "@common/components/alert/dialog/Dialog"
import FilledButtonM from "@common/components/button/FilledButtonM"
import IconButtonM from "@common/components/button/IconButtonM"
import UncontrolledTextInputM from "@common/components/input/UncontrolledTextInputM"
import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import { useCamera } from "@common/hooks/useCamera"
import { useRequestsBatch } from "@common/hooks/useRequestsBatch"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { formIds } from "@data/constants/formConstants"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { clearLastPhoto, clearPhotos } from "@data/redux/actions/camera"
import { authService } from "@data/services/authService"
import * as DocumentPicker from "expo-document-picker"
import moment from "moment"
import React, { useContext, useEffect, useRef, useState } from "react"
import { FlatList, ScrollView, Vibration, View } from "react-native"
import { TouchableRipple } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import { ImageViewerModal, pickImage } from "../../common/camera/CameraImagesM"
import { checkIsPdf } from "../../common/components/pdf/pdfHelpers"
import PdfViewerModal from "../../common/components/pdf/PdfViewerModal"
import FileElement from "../../common/file/FileElement"
import {
    resetUploadedFiles,
    saveUploadedFiles,
} from "../../data/redux/actions/formData"

function SendTutorMessageModal(props) {
    const {
        subscriptionUser,
        isOpen,
        handleShowSendTutorMessageModal,
        sendTutorMessageTutor,
        formId,
    } = props
    const dimensions = useContext(DimensionsContext)

    const [message, setMessage] = useState("")

    const [openImageViewer, setOpenImageViewer] = useState(false)
    const [pdfViewerVisible, setPdfViewerVisible] = useState(false)
    const [selectedPdf, setSelectedPdf] = useState(null)
    const [visibleIndex, setVisibleIndex] = useState(0)
    const flatListRef = useRef()

    const [launchCamera] = useCamera(formId, true, true)

    useEffect(() => {
        if (
            props.lastPhotoFormId === formId &&
            !!props.lastPhoto &&
            !props.uploadedFiles
                ?.map((x) => x?.uri)
                ?.includes(props.lastPhoto?.uri)
        ) {
            const filesCopy = props.uploadedFiles?.map((x) => x) ?? []
            filesCopy.push(props.lastPhoto)
            props.saveUploadedFiles(formId, filesCopy)
            props.clearLastPhoto()
        } else if (
            props.lastPhotoFormId === formId &&
            props.lastPhotos?.length > 0
        ) {
            const filesCopy = props.uploadedFiles?.map((x) => x) ?? []
            filesCopy.push(...props.lastPhotos)
            props.saveUploadedFiles(formId, filesCopy)
            props.clearPhotos()
        }
    }, [props.lastPhoto, props.lastPhotos])

    useEffect(() => {
        flatListRef?.current?.scrollToEnd({ animated: false })
    }, [])

    const pickFromGallery = async () => {
        const currentFiles = props.uploadedFiles || []
        await pickImage(currentFiles, (updatedFiles) => {
            // pickImage adds the selected image to the array
            // Save to Redux
            props.saveUploadedFiles(formId, updatedFiles)
        })
    }

    const pickFile = async () => {
        const result = await DocumentPicker.getDocumentAsync({
            type: ["application/pdf", "image/*"],
        })

        if (!result.canceled) {
            const filesCopy = props.uploadedFiles?.map((x) => x) ?? []
            const name = result.assets[0]?.name
                .split(".")[0]
                .replace(/[\s.]+/g, "_")

            filesCopy.push({
                uri: result.assets[0]?.uri,
                name,
                width: result.assets[0]?.width ?? 200,
                height: result.assets[0]?.height ?? 200,
                selected: false,
            })
            props.saveUploadedFiles(formId, filesCopy)
        }
    }

    const onDelete = (index) => {
        Vibration.vibrate(50)

        props.saveUploadedFiles(
            formId,
            props.uploadedFiles?.filter((_, i) => i !== index)
        )
    }

    const filesToUpload = props.uploadedFiles
        ?.filter((file) => !file.id)
        .map((file) => {
            const type = checkIsPdf(file?.uri)
                ? "application/pdf"
                : "image/jpeg"

            return {
                uri: file?.uri,
                name: `${file?.name}_${moment().format("YYYY-MM-DD")}.${
                    type === "application/pdf" ? "pdf" : "jpg"
                }`,
                type,
            }
        })

    const submitMessages = () => {
        startRequests()
    }

    const [globalProgress, submitted, startRequests] = useRequestsBatch(
        [],
        filesToUpload,
        formIds.SEND_TUTOR_MESSAGE,
        {
            service: authService.sendMessageToTutor,
            data: {
                subscriptionUserID: subscriptionUser?.id,
                tutorId: sendTutorMessageTutor?.id,
                message: message,
            },
            tmpFilesKey: "message_attachments",
            tmpFilesFormatter: (attachmentTmp, index) => {
                return {
                    url: attachmentTmp,
                    name: filesToUpload[index]?.name,
                }
            },
            additionalData: [],
            onSuccessBeforeNext: () => {
                setMessage("")
                handleShowSendTutorMessageModal()
                DialogM.show({
                    text1: "Message envoyé ✅",
                    text2: "Votre message a bien été transmis.",
                })
                props.resetUploadedFiles(formId)
            },
            onError: () => {
                DialogM.show({
                    text1: "Erreur lors de l'envoi du message ❌",
                    text2: "Veuillez réessayer.",
                })
            },
        },
        [],
        true
    )

    const contentHeight = dimensions?.height * 0.4

    return (
        <ModalM
            visible={isOpen}
            onDismiss={handleShowSendTutorMessageModal}
            style={{
                width: dimensions.width > 800 ? "80%" : "90%",
                height: "90%",
                overflow: "hidden",
            }}
        >
            <ScrollView
                style={{
                    backgroundColor: theme.colors.white,
                    paddingHorizontal: 20,
                    borderBottomLeftRadius: 10,
                    borderBottomRightRadius: 10,
                    paddingTop: 30,
                }}
                contentContainerStyle={{}}
            >
                <TextM
                    fontWeight="Bold"
                    color={theme.colors.primary}
                    style={{
                        textAlign: "center",
                        paddingTop: 5,
                        paddingBottom: 20,
                        paddingHorizontal: 30,
                    }}
                    wrap={true}
                    fontSize={20}
                >
                    Transmettre un message au tuteur{" "}
                    {sendTutorMessageTutor?.display_name}
                </TextM>

                {props.isParentMode && (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            backgroundColor: theme.colors.primaryLighter,
                            borderRadius: 8,
                            padding: 10,
                            marginBottom: 10,
                        }}
                    >
                        <FontAwesome5
                            name="info-circle"
                            size={14}
                            color={theme.colors.primary}
                            style={{ marginRight: 8 }}
                        />
                        <TextM
                            fontSize={12}
                            color={theme.colors.primary}
                            fontWeight="Medium"
                            wrap
                            style={{ flex: 1 }}
                        >
                            Les messages envoyés au tuteur sont visibles par
                            l'élève.
                        </TextM>
                    </View>
                )}

                <UncontrolledTextInputM
                    placeholder="Message..."
                    name="message"
                    style={{
                        height: 150,
                        backgroundColor: theme.colors.white,
                        marginTop: 10,
                    }}
                    multiline={true}
                    numberOfLines={3}
                    value={message}
                    onChangeText={(value) => {
                        setMessage(value)
                    }}
                />

                <FlatList
                    data={props.uploadedFiles}
                    ref={flatListRef}
                    getItemLayout={(_, index) => ({
                        length: contentHeight,
                        offset: contentHeight * index,
                        index,
                    })}
                    horizontal
                    style={{
                        alignSelf: "center",
                        marginTop: 20,
                        height: dimensions?.height * 0.4,
                        width:
                            props.uploadedFiles?.length === 0 ? null : "100%",
                    }}
                    contentContainerStyle={{
                        alignItems: "center",
                        justifyContent: "center",
                        height: contentHeight,
                    }}
                    ListFooterComponent={() => (
                        <View style={{ height: contentHeight }}>
                            <TouchableRipple
                                onPress={() => {
                                    launchCamera()
                                    handleShowSendTutorMessageModal()
                                }}
                                underlayColor={theme.colors.lighter}
                                style={{
                                    flex: 1,
                                    width:
                                        props.uploadedFiles?.length === 0
                                            ? "100%"
                                            : 190,
                                }}
                            >
                                <View
                                    style={{
                                        flex: 1,
                                        marginHorizontal: 20,
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <FontAwesome5
                                        name={"camera"}
                                        size={32}
                                        color={theme.colors.primary}
                                    />
                                    <TextM
                                        wrap
                                        fontWeight="ExtraBold"
                                        color={theme.colors.primary}
                                        fontSize={18}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                        }}
                                    >
                                        {props.uploadedFiles?.length === 0
                                            ? "Prendre une photo"
                                            : "Ajouter une photo"}
                                    </TextM>
                                </View>
                            </TouchableRipple>
                            <TouchableRipple
                                onPress={() => {
                                    pickFromGallery()
                                }}
                                underlayColor={theme.colors.lighter}
                                style={{
                                    flex: 1,
                                    width:
                                        props.uploadedFiles?.length === 0
                                            ? "100%"
                                            : 190,
                                }}
                            >
                                <View
                                    style={{
                                        flex: 1,
                                        marginHorizontal: 20,
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <FontAwesome5
                                        name="images"
                                        size={32}
                                        color={theme.colors.primary}
                                    />
                                    <TextM
                                        wrap
                                        fontWeight="ExtraBold"
                                        color={theme.colors.primary}
                                        fontSize={18}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                        }}
                                    >
                                        Choisir depuis la galerie
                                    </TextM>
                                </View>
                            </TouchableRipple>
                            <TouchableRipple
                                onPress={() => {
                                    pickFile().then()
                                }}
                                underlayColor={theme.colors.lighter}
                                style={{
                                    flex: 1,
                                    width:
                                        props.uploadedFiles?.length === 0
                                            ? "100%"
                                            : 190,
                                }}
                            >
                                <View
                                    style={{
                                        flex: 1,
                                        marginHorizontal: 20,
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <FontAwesome5
                                        name="file-image"
                                        size={32}
                                        color={theme.colors.primary}
                                    />
                                    <TextM
                                        wrap
                                        fontWeight="ExtraBold"
                                        color={theme.colors.primary}
                                        fontSize={18}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                        }}
                                    >
                                        Choisir un fichier
                                    </TextM>
                                </View>
                            </TouchableRipple>
                        </View>
                    )}
                    keyExtractor={(_, index) => index.toString()}
                    renderItem={(itemInfo) => {
                        const isPdf = checkIsPdf(itemInfo.item?.uri)

                        return (
                            <FileElement
                                uri={itemInfo.item?.uri}
                                height={200}
                                width={200}
                                name={itemInfo.item?.name}
                                parentHeight={contentHeight}
                                selected={itemInfo.item?.selected}
                                onDelete={() => onDelete(itemInfo.index)}
                                onPress={() => {
                                    if (isPdf) {
                                        setSelectedPdf({
                                            uri: itemInfo.item?.uri,
                                            name: itemInfo.item?.name,
                                        })
                                        setPdfViewerVisible(true)
                                    } else {
                                        setOpenImageViewer(true)
                                        setVisibleIndex(itemInfo.index)
                                    }
                                }}
                            />
                        )
                    }}
                />

                <FilledButtonM
                    style={{
                        marginTop: 10,
                        marginBottom: 20,
                        marginLeft: 20,
                        marginRight: 20,
                        maxWidth: "85%",
                    }}
                    onPress={submitMessages}
                    loading={submitted}
                    disabled={
                        message === "" && props.uploadedFiles.length === 0
                    }
                    label={"Envoyer"}
                />
            </ScrollView>

            <IconButtonM
                icon={"times"}
                iconColor={theme.colors.primary}
                containerColor={theme.colors.whiteTransparent}
                style={{
                    position: "absolute",
                    top: -5,
                    left: -5,
                }}
                size={32}
                onPress={() => {
                    handleShowSendTutorMessageModal()
                }}
            />

            <ImageViewerModal
                visible={openImageViewer}
                onDismiss={() => setOpenImageViewer(false)}
                imageIndex={props.uploadedFiles.length > 0 ? 0 : undefined}
                images={[props.uploadedFiles[visibleIndex]].map((x) => x?.uri)}
            />

            <PdfViewerModal
                visible={pdfViewerVisible}
                onDismiss={() => setPdfViewerVisible(false)}
                pdfFile={selectedPdf}
            />
        </ModalM>
    )
}

const mapStateToProps = (state) => {
    return {
        lastPhoto: state.camera?.lastPhoto,
        lastPhotos: state.camera?.lastPhotos,
        lastPhotoFormId: state.camera?.formId,
        uploadedFiles:
            state.data.formData?.uploadedFiles?.[formIds.SEND_TUTOR_MESSAGE] ||
            [],
        isParentMode: state.data.family?.isParentMode,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    clearLastPhoto,
    clearPhotos,
    saveUploadedFiles,
    resetUploadedFiles,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SendTutorMessageModal)
